<template>
<div class="rp-page">
  <div class="page-top">
    <img src="https://assets.rurushishi.com/yq-rs-make/car/mobile/images/ticket-top-bg-img.png" class="form-bg" mode="aspectFill"/>
    <div class="form">
        <div class="row">
          <div class="field">手机号：</div>
          <div class="input">
            <input placeholder="请输入手机号" v-model="pickParam.mobile" placeholderClass="form-hd"/>
          </div>
        </div>
        <div class="row">
          <div class="field">验证码：</div>
          <div class="input">
            <input placeholder="请输入的验证码" v-model="pickParam.verCode" placeholderClass="form-hd"/>
            <span v-if="seCount > 0" class="btn-getCode">{{seCount + '秒后获取'}}</span>
            <span v-else class="btn-getCode" @click="getVerifyCode">获取验证码</span>
          </div>
        </div>
        <div class="row-remark">
          <p>
            <span class="title">温馨提醒：</span>领取1000元购车优惠券后，可在签订购车合同时抵扣，赶快领取吧！
          </p>
        </div>
        <div class="btn-row">
          <button class="btn-get" @click="onPickFreeTick">立即领取</button>
        </div>
    </div>
  </div>
  <div class="rec-con">
      <div class="title">推荐车型</div>
      <div class="list-con">
        <com-rec-car-list hiddenFilter/>
      </div>
  </div>
</div>
</template>

<script>
import { mapState } from "vuex"
import { Toast } from 'mint-ui'
import ComRecCarList from '../components/list/comRecCarList'
import {pickTicket, smsSender, getTicketList, getProjectByChlid, createClue} from '../api'

export default {
  components: {
    ComRecCarList
  },
  props: {},
  data() {
    return {
      seCount: 0,
      intervalid: null,
      reqHeader: {
        openid: "",
        appId: "",
        channelId: ""
      },
      threadInfo: {
        appid: "",
        atype: 6,
        mobile: "",
        username: "",
        refereeopenid: "",
        msg: ""
      },
      pickParam: {
        addSource: 1,
        mobile: "",
        couponId: "",
        name: "",
        projectId: 0,
        projectName: "",
        verCode: ""
      }
    };
  },
  watch: {
    userInfo(newInfo){
      const { user: { openid, appid, nickname}} = newInfo
      this.reqHeader.openid = openid
      this.reqHeader.appId = appid
      this.threadInfo.appid = appid
      this.threadInfo.username = nickname
      this.threadInfo.refereeopenid = openid
      this.initPage().then(res => {})
    }
  },
  computed: {
    ...mapState([
      "isInMiniProgram",
      "userInfo"
    ])
  },
  methods: {
    async onPickFreeTick(){
      const { pickParam } = this
      if(pickParam.mobile.length === 0){
        Toast('请输入手机号!')
        return ;
      }
      if(pickParam.verCode.length === 0){
        Toast('请输入验证码!')
        return ;
      }
      const ret = await pickTicket(pickParam, this.reqHeader)
      if(ret.code === 0){
        Toast('优惠券，领取成功!')
        this.threadInfo.mobile = pickParam.mobile
        this.threadInfo.msg = "已优惠领券！"
        await createClue(this.threadInfo) //同步一份信息到线索接口
        Object.keys(pickParam).forEach(key => {
          this.pickParam[key] = ''
        })
      }
    },
    async initPage(){
      const retList = await getTicketList(this.reqHeader)
      const retProj = await getProjectByChlid(this.reqHeader.channelId, this.reqHeader)
      if(retList.code === 0 && retList.data && retList.data.length > 0){
        this.pickParam.couponId = retList.data[0].id
        this.pickParam.name = retList.data[0].name
      }
      if(retProj.code === 0 && retProj.data && retProj.data.length > 0){
         const project = retProj.data[0]
         this.pickParam.projectId = project.projectId
         this.pickParam.projectName = project.projectName
      }
    },
    startCountDown(){
      this.intervalid = setInterval(()=>{
        this.seCount --
        if(this.seCount === 0){
          clearInterval(this.intervalid)
        }
      }, 1000)
    },
    async getVerifyCode(){
      if(!/1\d{10}/i.test(this.pickParam.mobile)){
        Toast('请输入正确手机号码!')
        return 
      }
      const ret = await smsSender(this.pickParam.mobile, this.reqHeader)
      if(ret.code === 0){
        this.seCount = 59
        this.startCountDown()
      }
    }
  },
  beforeCreate() {},
  created() {
    this.reqHeader.channelId = this.$route.query.channelid
  }
};
</script>
<style lang="scss" scoped>
.rp-page{
    width: 100%;
    .page-top{
        width: 100%;
        position: relative;
        .form-bg{
            width: 100%;
            height: 8.615446989661464rem;
        }
        .form{
            position: absolute;
            top: 0px;
            z-index: 2;
            width: 100%;
            input::placeholder{
                background: #fff;
                color:#ccc;
                font-size: .26rem;
            }
            .row{ 
                margin: 0.5067909993918508rem 1.0135819987837016rem 0.20271639975674033rem 1.0135819987837016rem;
                background-color: #fff;
                height: 0.8108655990269613rem;
                border-radius: 40px;
                display: flex;
                align-items: center;
                .field{
                    width: 1.5203729981755525rem;
                    font-size: 0.2635313196837624rem;
                    color:#834BF7;
                    display:flex;
                    align-items: center;
                    text-indent: 0.40543279951348066rem;
                    height: 0.8108655990269613rem;
                }
                .input{
                    flex: 1;
                    position: relative;
                    input{color:#555;}
                    .btn-getCode{
                        position: absolute;
                        color:#834BF7;
                        width: 1.6rem;
                        text-align: right;
                        border-left: solid 1px #834BF7;
                        font-size: 0.24rem;
                        top: .1rem;                        
                        right: .28rem;
                        z-index: 3;
                    }
                }
            }
            .btn-row{
                display: flex;
                justify-content: center;
                padding-top: 0.31rem;
            }
            .row-remark{
              padding:.1rem 1.1rem;
              p{                
                color:#fff;
                font-size: .24rem;
                line-height: .5rem;
                .title{
                  color:#ff7b3b;
                }
              }
            }
            .btn-get{
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 0.2432596797080884rem;
                color:#fff;
                width: 3.4867220758159334rem;
                height: 0.8108655990269613rem;
                background: #FFAD19;
                box-shadow: 0px 0.040543279951348064rem 0.16217311980539226rem 0px rgba(34, 3, 100, 0.4);
                border-radius: 40px;
            }
        }
    }
    .rec-con{
        box-sizing: border-box;
        margin: 0.30407459963511047rem 0.30407459963511047rem 0px 0.30407459963511047rem;
        background: #FFFFFF;
        box-shadow: 0px 0.040543279951348064rem 0.15203729981755523rem 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        .title{
            font-size: 0.3243462396107845rem;
            color:#313131;
            padding: 0.3rem .3rem;
        }
        .list-con{
            width: 100%;
        }
    }
}
.form-hd{
    color:#aaa;
    font-size:0.2635313196837624rem;
}
</style>